
const coursesCollection = "Courses"

export {coursesCollection};